module.exports = __webpack_public_path__ + "static/media/logo1024x1024.2aa86c67.png";